module.exports = __webpack_public_path__ + "fonts/MaterialIcons-Regular.eot";


//////////////////
// WEBPACK FOOTER
// ./src/js/core/fonts/MaterialIcons-Regular.eot
// module id = 20
// module chunks = 0